import React, { useEffect, useState } from 'react';
import EnhancedTable from 'components/tables/EnhancedTable';
import { useAuthStateShared, useSubscriptionState, useWeb3 } from 'state';
import AddressFieldTools from 'components/AddressFieldTools';
import { Typography, Card, Box, List, ListItem, ListItemText, useTheme, useMediaQuery,Divider} from '@mui/material';
import InvestorTableSummary from './InvestorTableSummary';
import DataNotAvailable from 'helpers/DataNotAvailable';

export default function IssuerViewRedemptions({
  poolAddr,
  currentToken,
  refetchDetails,
  refetchRedemption
}) {
  const { redeemedAllotments, fetchRedeemedAllotments } = useSubscriptionState();
  const [data, setData] = useState(redeemedAllotments);
  const { account } = useWeb3();
  const [skipPageReset, setSkipPageReset] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const fetchAccount = poolAddr || account;

  useEffect(() => {
    if (account && currentToken?.token_id) {
      fetchRedeemedAllotments(fetchAccount, currentToken?.token_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentToken, account, refetchDetails, refetchRedemption]);

  useEffect(() => {
    setData(redeemedAllotments);
  }, [redeemedAllotments]);

  const refreshAllotments = () => {
    if (account && currentToken?.token_id) {
      fetchRedeemedAllotments(fetchAccount, currentToken?.token_id);
    }
  };

  const headCells = [
    // {
    //   accessor: 'token.token_symbol',
    //   Header: 'Token Symbol',
    //   width: 80,
    //   show: true
    // },
    // {
    //   accessor: '',
    //   Header: 'Token Address',
    //   show: true,
    //   width: 200,
    //   Cell: ({ row: { original } }) => {
    //     return (
    //       <AddressFieldTools
    //         address={original.token.deployment_address}
    //         decimals={0}
    //         showCopyButton
    //         showInBlockExplorer
    //       />
    //     );
    //   }
    // },
    {
      accessor: 'token.token_name',
      Header: 'Token Name',
      width: 90,
      show: true
    },
    {
      accessor: 'redeemed_qty',
      Header: 'Quantity',
      width: 70,
      show: true
    },
    {
      accessor: 'redemption_date',
      Header: 'Redemption Date',
      width: 110,
      show: true,
      Cell: ({ row: { original } }) => {
        return <>{original.redemption_date ?? '-'}</>;
      }
    },
    {
      accessor: 'buy_price',
      Header: 'Buy Price ($)',
      width: 80,
      show: true
    },
    {
      accessor: 'token_price',
      Header: 'Redemption Price ($)',
      width: 110,
      show: true
    },
    {
      accessor: 'redemption_status_title',
      Header: 'Redemption Status',
      width: 110,
      show: true,
      Cell: ({ row: { original } }) => {
        return <>{original.redemption_status_title.replace('_', ' ')}</>;
      }
    }
  ];

  const updateMyData = (rowIndex, columnId, value) => {
    setSkipPageReset(true);
    setData((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value
          };
        }
        return row;
      })
    );
  };

  return (
    <>
      {data?.length > 0 && <InvestorTableSummary data={data[0]} />}

      {isMobile ? (
        <Box>
        {data.length !== 0 ? (  
          data.map((row, idx) => (
            <Card key={row.id || idx} sx={{ mb: 2, p: 2 }}>
              <List dense>
                <ListItem>
                  <ListItemText primary="Token Name" secondary={row.token?.token_name} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Quantity" secondary={row.redeemed_qty} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Redemption Date" secondary={row.redemption_date ?? '-'} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Buy Price ($)" secondary={row.buy_price} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Redemption Price ($)" secondary={row.token_price} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Redemption Status" secondary={row.redemption_status_title?.replace('_', ' ')} />
                </ListItem>
              </List>
            </Card>
          ))
        ): (
        <Box>
          <DataNotAvailable sx={{ height: '10rem', mt: 2 }} />
        </Box>
         )}
        </Box>
      ) : (
        <EnhancedTable
          tableTitle="InvestorViewRedemption"
          columns={headCells}
          data={data}
          setData={setData}
          updateMyData={updateMyData}
          skipPageReset={skipPageReset}
          refreshFunction={refreshAllotments}
          setMinWidth
        />
      )}
    </>
  );
}
